import { RootState } from '@reducers';

export const selectFeatureIngestion = (state: RootState) => state.featureReducer.ingestionReducer;
